import { render } from "./DisabledButton.vue?vue&type=template&id=5500d674"
import script from "./DisabledButton.vue?vue&type=script&lang=ts"
export * from "./DisabledButton.vue?vue&type=script&lang=ts"
script.render = render

export default script